import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton } from '@mui/material';

import { toggleProjectGridRowExpansion } from '../../store/actions/projectGrid';
import { useAppDispatch, useAppSelector } from '../hooks';

export function ProjectGridExpandCollapseButton(props: { readonly rowId: string }) {
  const dispatch = useAppDispatch();

  const isExpanded = useAppSelector((state) => state.grid.expandedRows.includes(props.rowId));

  return (
    <IconButton
      onClick={(event) => {
        event.stopPropagation();
        void dispatch(toggleProjectGridRowExpansion(props.rowId));
      }}
    >
      {isExpanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
    </IconButton>
  );
}
